import styled from 'styled-components'

import { Button as BaseButton, disabledOpacity } from '@redriverpress/system'

const Button = styled(BaseButton).attrs(({ opacity, disabled }) => ({
  opacity: opacity === undefined && disabled ? disabledOpacity : opacity,
}))``

export default Button
